<aside class="drawer drawer-default">
  <div class="drawer-header">
    <div class="drawer-header__title">
      <button class="btn mb-0 p-2" (click)="closeDrawer()">
        <img src="/assets/icons/menu-drawer-close.svg" alt="close" />
      </button>
    </div>
  </div>
  <div class="drawer-body">
    <ng-content select="[drawerBody]"></ng-content>
  </div>
  <footer class="drawer-footer">
    <ng-content select="[drawerFooter]"></ng-content>
  </footer>
</aside>
<div class="backdrop"></div>
